export const MODULE_NAME = 'dataInsightTrackingModule';
export const DEBOUNCE_INTERVAL = 1000; // in ms
